import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import MetaDescription from '@chegg-wt/core/components/Head/MetaDescription'
import SourceSearch, {
  SourceSearchPageStructureTop,
} from '@chegg-wt/core/components/Layouts/SourceSearch'
import { getLvpLayout } from '@chegg-wt/core/components/Layouts/LargeVideoPlayerLayout'
import { NextPageWithLayout } from '@chegg-wt/core/types/layout'
import { getActualStyleId } from '@chegg-wt/core/utils/styles'
import { getUrlStyleNameV2 } from '@chegg-wt/core/api/oneGraph'
import { Config } from '@chegg-wt/core/config'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import { TRY_IT_FOR_FREE_CTA } from '@chegg-wt/core/components/UpgradeAdFrame/constants'
import { findPageCredibility } from '../../copy/credibility'
import { upgradePromotionCopy } from '../../copy/upgrade'

interface SourceSearchPageProps {
  initialUrlStyleName: string
}

const SourceSearchPage: NextPageWithLayout<SourceSearchPageProps> = ({
  initialUrlStyleName,
}) => {
  const urlStyle = 'apa7'
  const source = 'website'

  useOnUnloadTimeOnPage()
  return (
    <>
      <SEOTitle title="Try Our Free APA Citation Generator & APA Format Guide" />
      <MetaDescription content="Looking for an APA citation generator and complete APA format guide? Look no further! Our free resources make citing in APA style a breeze." />
      <SourceSearch
        copy={{
          considerCredibility: findPageCredibility,
          upgradePromotionCopy: {
            ...upgradePromotionCopy,
            buttonText: TRY_IT_FOR_FREE_CTA,
          },
        }}
        styleId={getActualStyleId(urlStyle)}
        initialUrlStyleName={initialUrlStyleName}
        initialSourceType={source}
      />
    </>
  )
}

export const getServerSideProps = async () => {
  const styleId = 'apa7'
  const currentSourceType = 'website'
  const [initialUrlStyleName] = await getUrlStyleNameV2(styleId)

  return {
    props: {
      initialUrlStyleName,
      isDefaultStyle: Config.currentStyle === styleId,
      currentSourceType,
    },
  }
}

SourceSearchPage.getPageLayout = (page, ssrProps) =>
  getLvpLayout(page, () => <SourceSearchPageStructureTop {...ssrProps} />)

export default SourceSearchPage
